import React from 'react';

function ProtectedImage({ src, alt, className, style }) {
  if (!src) {
    return <div className={className} style={{ ...style, background: '#f3f4f6' }} />;
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      draggable={false}
    />
  );
}

export default ProtectedImage;
